import { css } from 'aphrodite';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '../../../../web/components-v2/Button';
import { formatCurrency } from '../../../../web/utils/formatCurrency';
import { getCollectPaymentResult } from '../CollectPayment';
import { CreateSubscriptionFromOfferResult } from '../PricingWizard/types';
import { styleSheet } from './styles';

interface StoredData {
	result: CreateSubscriptionFromOfferResult;
	accountId?: string;
}

export function CollectPaymentConfirmation() {
	const history = useHistory();

	// Read result from memory (hash history doesn't support state)
	// The getter clears the data after reading to prevent stale data
	const storedData = React.useMemo<StoredData | null>(() => {
		const data = getCollectPaymentResult();
		return data as StoredData | null;
	}, []);

	const result = storedData?.result;
	const accountId = storedData?.accountId;

	// If no result, redirect back
	React.useEffect(() => {
		if (!result) {
			history.replace('/tools/pricing-wizard');
		}
	}, [result, history]);

	if (!result) {
		return null;
	}

	const isActive = result.state === 'active';

	return (
		<div className={css(styleSheet.container)}>
			<div className={css(styleSheet.content)}>
				<div className={css(styleSheet.successIcon)}>✓</div>
				<h1 className={css(styleSheet.title)}>{isActive ? 'Payment Successful!' : 'Subscription Created!'}</h1>
				<p className={css(styleSheet.subtitle)}>
					{isActive
						? 'The subscription has been created and payment has been collected.'
						: 'The subscription has been created. An invoice will be sent to the customer.'}
				</p>

				<div className={css(styleSheet.detailsCard)}>
					<div className={css(styleSheet.detailRow)}>
						<span className={css(styleSheet.detailLabel)}>Subscription ID:</span>
						<span className={css(styleSheet.detailValue)}>{result.subscriptionId}</span>
					</div>
					<div className={css(styleSheet.detailRow)}>
						<span className={css(styleSheet.detailLabel)}>Customer ID:</span>
						<span className={css(styleSheet.detailValue)}>{result.customerId}</span>
					</div>
					<div className={css(styleSheet.detailRow)}>
						<span className={css(styleSheet.detailLabel)}>Product:</span>
						<span className={css(styleSheet.detailValue)}>{result.productName}</span>
					</div>
					<div className={css(styleSheet.detailRow)}>
						<span className={css(styleSheet.detailLabel)}>Amount Charged:</span>
						<span className={css(styleSheet.amountHighlight)}>
							${formatCurrency(result.totalAmountBilledToday, { forceDecimals: true })}
						</span>
					</div>
				</div>

				{accountId && (
					<div className={css(styleSheet.buttonRow)}>
						<Button variant='primary' onClick={() => history.push(`/accounts/${accountId}?openScheduleMeeting=true`)}>
							View Account & Schedule
						</Button>
					</div>
				)}
			</div>
		</div>
	);
}
